module.exports = "/assets/dist/images/manual.svg?ee934520f5a773914a50a2cf2e6829aa";